import { render } from "./AnketaPage.vue?vue&type=template&id=7e85a610&scoped=true"
import script from "./AnketaPage.vue?vue&type=script&lang=js"
export * from "./AnketaPage.vue?vue&type=script&lang=js"

import "./AnketaPage.vue?vue&type=style&index=0&id=7e85a610&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e85a610"]])

export default __exports__